import React from 'react'
import without from 'lodash/without'
import FormSwitch from 'components/forms/bases/FormSwitch'
import { addDelimeterBetweenItems } from 'helpers/stringHelpers'

const parseToForm = (value) => {
  // remove unused device
  const removedValue = value.replace(' large screen widescreen', '')
  return removedValue.split(' ')
}

const attachBeyondComputerDevice = (appears) => {
  return appears.indexOf('computer') !== -1 ?
    appears.concat('large screen widescreen')
    :
    appears
}

const createAppearsAfterChange = (appears, device, val) => {
  if(val) {
    // val is true, add device to list
    return attachBeyondComputerDevice(appears.concat(device))
  }
  // remove device from list first
  // then see that whether attach other device beyond computer or not
  return attachBeyondComputerDevice(without(appears, device))
}

const returnValue = (appears, device, val) => {
  return addDelimeterBetweenItems(
    createAppearsAfterChange(appears, device, val),
    ' '
  )
}

const AppearanceToggle = ({
  value, // 'mobile tablet large screen'
  device,
  onChange,
  ...props,
}) => {
  const appears = parseToForm(value)
  return (
    <FormSwitch
      {...props}
      value={appears.indexOf(device) !== -1}
      onChange={(val) => onChange(returnValue(appears, device, val))}
    />
  )
}

AppearanceToggle.propTypes = {}
AppearanceToggle.defaultProps = {}

export default AppearanceToggle



// WEBPACK FOOTER //
// ./src/components/forms/AppearanceToggle.js